import { NotFound } from '@meteor/pages';
import { ModalRoot, Toaster } from '@meteor/ui';
import { useEffect, useRef } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { RouterErrorPage } from './pages/_error/routerError';
import { Layout } from './pages/_layout';
import { AdminsPage } from './pages/admin/page';
import { AgentTemplatePage } from './pages/agents/[agentTemplateId]/page';
import { AgentsPage } from './pages/agents/page';
import { AuthConfigPage } from './pages/auth-config';
import { EarlyAccessPage } from './pages/early-access/page';
import { InvitesPage } from './pages/invites/page';
import { LoginPage } from './pages/login';
import { OrganizationPage } from './pages/organizations/[organizationId]/page';
import { OrganizationsPage } from './pages/organizations/page';
import { UserPage } from './pages/users/[userId]/page';
import { UsersPage } from './pages/users/page';

let Redirect = ({ to }: { to: string }) => {
  let navigatingRef = useRef(false);
  useEffect(() => {
    if (navigatingRef.current) return;
    navigatingRef.current = true;
    window.location.replace(to);
  }, [to]);
  return null;
};

let router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <Outlet />
        <Toaster />
        <ModalRoot />
      </>
    ),
    errorElement: <RouterErrorPage />,
    children: [
      {
        path: '',
        element: <Redirect to="https://app.metorial.com" />
      },
      {
        path: 'login',
        element: <LoginPage />
      },
      {
        path: '',
        element: <Layout />,
        children: [
          { path: 'users', element: <UsersPage /> },
          { path: 'users/:userId', element: <UserPage /> },
          { path: 'agents', element: <AgentsPage /> },
          { path: 'agents/:agentTemplateId', element: <AgentTemplatePage /> },
          { path: 'organizations', element: <OrganizationsPage /> },
          { path: 'organizations/:organizationId', element: <OrganizationPage /> },
          { path: 'auth-config', element: <AuthConfigPage /> },
          { path: 'admins', element: <AdminsPage /> },
          { path: 'invites', element: <InvitesPage /> },
          { path: 'early-access', element: <EarlyAccessPage /> }
        ]
      }
    ]
  }
]);

export let App = () => {
  return <RouterProvider router={router} fallbackElement={<NotFound />} />;
};
